export type Graph =
  | "headachesPerMonth"
  | "migrainesPerMonth"
  | "nonMigrainesPerMonth";

const graphNames: { [key in Graph]: string } = {
  headachesPerMonth: "Headaches Per Month",
  migrainesPerMonth: "Migraines Per Month",
  nonMigrainesPerMonth: "Non-migraines Per Month",
};

export const toGraphName = (s: Graph) => graphNames[s];

export const ALL_GRAPH_NAMES: Graph[] = [
  "headachesPerMonth",
  "migrainesPerMonth",
  "nonMigrainesPerMonth",
];
